import {baseStyleProps as $63d03c54ca5e4b88$export$fe9c6e915565b4e8, dimensionValue as $63d03c54ca5e4b88$export$abc24f5b99744ea6, passthroughStyle as $63d03c54ca5e4b88$export$46b6c81d11d2c30a, useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {useDOMRef as $3c2c983d5210446c$export$c2c55ef9111cafd8} from "../utils/useDOMRef.mjs";
import {filterDOMProps as $01IFO$filterDOMProps} from "react-aria/filterDOMProps";
import $01IFO$react, {forwardRef as $01IFO$forwardRef} from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



const $572f9fec526c2697$var$gridStyleProps = {
    ...(0, $63d03c54ca5e4b88$export$fe9c6e915565b4e8),
    autoFlow: [
        'gridAutoFlow',
        (0, $63d03c54ca5e4b88$export$46b6c81d11d2c30a)
    ],
    autoColumns: [
        'gridAutoColumns',
        $572f9fec526c2697$var$gridDimensionValue
    ],
    autoRows: [
        'gridAutoRows',
        $572f9fec526c2697$var$gridDimensionValue
    ],
    areas: [
        'gridTemplateAreas',
        $572f9fec526c2697$var$gridTemplateAreasValue
    ],
    columns: [
        'gridTemplateColumns',
        $572f9fec526c2697$var$gridTemplateValue
    ],
    rows: [
        'gridTemplateRows',
        $572f9fec526c2697$var$gridTemplateValue
    ],
    gap: [
        'gap',
        (0, $63d03c54ca5e4b88$export$abc24f5b99744ea6)
    ],
    rowGap: [
        'rowGap',
        (0, $63d03c54ca5e4b88$export$abc24f5b99744ea6)
    ],
    columnGap: [
        'columnGap',
        (0, $63d03c54ca5e4b88$export$abc24f5b99744ea6)
    ],
    justifyItems: [
        'justifyItems',
        (0, $63d03c54ca5e4b88$export$46b6c81d11d2c30a)
    ],
    justifyContent: [
        'justifyContent',
        (0, $63d03c54ca5e4b88$export$46b6c81d11d2c30a)
    ],
    alignItems: [
        'alignItems',
        (0, $63d03c54ca5e4b88$export$46b6c81d11d2c30a)
    ],
    alignContent: [
        'alignContent',
        (0, $63d03c54ca5e4b88$export$46b6c81d11d2c30a)
    ]
};
const $572f9fec526c2697$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $01IFO$forwardRef)(function Grid(props, ref) {
    let { children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(otherProps, $572f9fec526c2697$var$gridStyleProps);
    if (styleProps.style) styleProps.style.display = 'grid'; // inline-grid?
    let domRef = (0, $3c2c983d5210446c$export$c2c55ef9111cafd8)(ref);
    return /*#__PURE__*/ (0, $01IFO$react).createElement("div", {
        ...(0, $01IFO$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, children);
});
function $572f9fec526c2697$export$76d90c956114f2c2(count, repeat) {
    return `repeat(${count}, ${$572f9fec526c2697$var$gridTemplateValue(repeat)})`;
}
function $572f9fec526c2697$export$9c1b655deaca4988(min, max) {
    return `minmax(${$572f9fec526c2697$var$gridDimensionValue(min)}, ${$572f9fec526c2697$var$gridDimensionValue(max)})`;
}
function $572f9fec526c2697$export$2f0b47b0911ce698(dimension) {
    return `fit-content(${$572f9fec526c2697$var$gridDimensionValue(dimension)})`;
}
function $572f9fec526c2697$var$gridTemplateAreasValue(value) {
    return value.map((v)=>`"${v}"`).join('\n');
}
function $572f9fec526c2697$var$gridDimensionValue(value) {
    if (/^max-content|min-content|minmax|auto|fit-content|repeat|subgrid/.test(value)) return value;
    return (0, $63d03c54ca5e4b88$export$abc24f5b99744ea6)(value);
}
function $572f9fec526c2697$var$gridTemplateValue(value) {
    if (Array.isArray(value)) return value.map($572f9fec526c2697$var$gridDimensionValue).join(' ');
    return $572f9fec526c2697$var$gridDimensionValue(value);
}


export {$572f9fec526c2697$export$ef2184bd89960b14 as Grid, $572f9fec526c2697$export$76d90c956114f2c2 as repeat, $572f9fec526c2697$export$9c1b655deaca4988 as minmax, $572f9fec526c2697$export$2f0b47b0911ce698 as fitContent};
//# sourceMappingURL=Grid.mjs.map
